export const getAbsaetzeBaseUrl = (hauptantragIndex: number) =>
  `/geld-einklagen/anwaltschaft/tatsachenvortrag-beweise/hauptantrag/${hauptantragIndex}/absaetze`;
